export default __webpack_public_path__ + "static/media/dice.021a7158.svg";